// import React, { useState, useEffect } from "react";
// import { authSelector } from "../../store/selectors/index";
// import { useSelector } from "react-redux";
// import { message } from "antd";
// import Example from "./calling.js";
// import Header from "../header/header";
// import { getAllItemsSearch, getSaleReg } from "../../api/endpoints/search.js";
// import { Select } from "antd";

// const { Option } = Select;

// const SaleRegister = () => {
//   const { user, access_token } = useSelector(authSelector);
//   const [itemsQueue, setItemsQueue] = useState([]);
//   const [state, setState] = useState({
//     items: [],
//     startingDate: "",
//     endingDate: "",
//     itemCode: "",
//     itemName: "",
//   });

//   // const onChangeText = (e, object) => {
//   //   if (object) {
//   //     const { name, value } = object;
//   //     setState({
//   //       ...state,
//   //       [name]: value,
//   //     });
//   //   } else {
//   //     const { name, value } = e.target;
//   //     setState({
//   //       ...state,
//   //       [name]: value,
//   //     });
//   //   }
//   // };

//   const onChangeText = (e, object) => {
//     if (object) {
//       const { name, value } = object;
//       setState({
//         ...state,
//         [name]: value,
//       });
//     } else {
//       const { name, value } = e.target;

//       // Format the datetime-local value to the desired format
//       const formattedValue = value.replace("T", " ");

//       setState({
//         ...state,
//         [name]: formattedValue,
//       });
//     }
//   };

//   const clearState = () => {
//     setItemsQueue([]);
//   };

//   const clearFields = () => {
//     setState({
//       items: state.items,
//       partyId: "",
//       partyName: "",
//       itemCode: "",
//       itemName: "",
//       endingDate: "",
//       startingDate: "",
//     });
//   };

//   const editHandler = async (e) => {
//     if (!state.startingDate && !state.endingDate)
//       return message.error("Please type date !");
//     // if (!state.itemCode) return message.error("Please type Item !");
//     let data = {
//       startingDate: state.startingDate,
//       endingDate: state.endingDate,
//       itemCode: state.itemCode,
//       siteId: Number(user.siteId),
//     };

//     console.log(state, "ressaaaaa");
//     console.log(data, "data");

//     const results = await getSaleReg(data, access_token);
//     console.log(results.data, "resulttt");
//     if (results.data.length === 0) {
//       message.error("No Record Found in this date");
//     }
//     if (results.success) {
//       const payload = results.data.reduce((acc, curr) => {
//         return [
//           ...acc,
//           {
//             itemCode: Number(curr.itemCode),
//             itemName: curr.items[0].itemName,
//             quantity: Number(curr.saledata[0].quantity),
//             amount: Number(curr.saledata[0].amount),
//           },
//         ];
//       }, []);
//       setItemsQueue(payload);
//       console.log(itemsQueue, "FUn");
//     } else {
//       message.error(results.message);
//     }
//   };

//   const getAllData = async () => {
//     const _items = await getAllItemsSearch(access_token);
//     setState({
//       ...state,
//       items: _items,
//     });
//   };
//   useEffect(() => {
//     getAllData();

//     //eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   console.log(state, "payy");

//   return (
//     <>
//       {itemsQueue.length > 0 ? (
//         <>
//           <div style={{ backgroundColor: "" }}>
//             {itemsQueue.length > 0 && (
//               <Example
//                 item={itemsQueue}
//                 enteredOn={state.startingDate}
//                 endingDate={state.endingDate}
//                 itemName={state.itemName}
//               />
//             )}
//           </div>
//           <div className="pb-3 flex justify-center">
//             <button
//               className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
//               onClick={clearState}
//             >
//               Exit
//             </button>
//           </div>
//         </>
//       ) : (
//         <>
//           <div className="">
//             <div className="h-full  w-full">
//               <Header />
//               <div className="flex  justify-center mt-10">
//                 <div className=" ml-10 mt-5 mr-10">
//                   <div className="loginHeading p-2 headingBox flex justify-center">
//                     <h1 className="text-white ">Sale Register</h1>
//                   </div>
//                   <div className="flex flex-col content-center items-center justify-items-center justify-evenly">
//                     <div className="mt-4">
//                       <div className="flex items-center">
//                         <label className="text-black" htmlFor="startDate">
//                           Starting Date:
//                         </label>
//                         <input
//                           type="datetime-local"
//                           name="startingDate"
//                           className="text-black inpTxt p-2 h-8 ml-3 mb-3"
//                           onChange={onChangeText}
//                         />
//                         <label className="text-black ml-5" htmlFor="endDate">
//                           Ending Date:
//                         </label>
//                         <input
//                           type="datetime-local"
//                           name="endingDate"
//                           className="text-black inpTxt p-2 h-8 ml-3 mb-3"
//                           onChange={onChangeText}
//                         />
//                       </div>
//                     </div>
//                     <div className="flex pb-3 items-center">
//                       <Select
//                         showSearch
//                         placeholder="Select item"
//                         className="mt-2 ml-3 h-8 p-1 w-36"
//                         optionFilterProp="children"
//                         value={state.itemCode || "Item"}
//                         onChange={(e) => {
//                           const { itemName: productName } = state.items.find(
//                             (el) => el.itemCode === e
//                           );
//                           setState({
//                             ...state,
//                             itemCode: e,
//                             itemName: productName,
//                           });
//                         }}
//                       >
//                         {state.items.map((el) => (
//                           <Option value={el.itemCode}>{el.itemCode}</Option>
//                         ))}
//                       </Select>
//                       <Select
//                         showSearch
//                         placeholder="Select Product Name"
//                         optionFilterProp="children"
//                         className="mt-2 ml-3 h-8 p-1 w-60"
//                         value={state.itemName || "Prodct Name"}
//                         onChange={(e) => {
//                           const { itemName: productName } = state.items.find(
//                             (el) => el.itemCode === e
//                           );
//                           setState({
//                             ...state,
//                             itemCode: e,
//                             itemName: productName,
//                           });
//                         }}
//                       >
//                         {state.items.map((el) => (
//                           <Option
//                             value={el.itemCode}
//                           >{`${el.itemCode} - ${el.itemName}`}</Option>
//                         ))}
//                       </Select>
//                       <button
//                         className="loginBtn text-white mt-2 ml-3 py-1 px-4 rounded"
//                         onClick={editHandler}
//                       >
//                         View
//                       </button>
//                       <button
//                         onClick={clearFields}
//                         className="loginBtn text-white mt-2 ml-3 py-1 px-4 rounded"
//                       >
//                         Clear
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}
//     </>
//   );
// };

// export default SaleRegister;
// import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
// import { authSelector } from "../../store/selectors";
// import { message, Select } from "antd";
// import Header from "../header/header";
// import { getAllItemsSearch, getSaleReg } from "../../api/endpoints/search";
// import jsPDF from "jspdf";
// import "jspdf-autotable";

// const { Option } = Select;

// const SaleRegister = () => {
//   const { user, access_token } = useSelector(authSelector);
//   const [itemsQueue, setItemsQueue] = useState([]);
//   const [state, setState] = useState({
//     items: [],
//     startingDate: "",
//     endingDate: "",
//     itemCode: "",
//     itemName: "",
//   });

//   useEffect(() => {
//     const fetchItems = async () => {
//       const result = await getAllItemsSearch(access_token);
//       if (result.success) {
//         setState(prevState => ({
//           ...prevState,
//           items: result.data,
//         }));
//       }
//     };
//     fetchItems();
//   }, [access_token]);

//   const onChangeText = (event) => {
//     const { name, value } = event.target;
//     setState(prevState => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const clearState = () => {
//     setItemsQueue([]);
//   };

//   const clearFields = () => {
//     setState(prevState => ({
//       ...prevState,
//       startingDate: "",
//       endingDate: "",
//       itemCode: "",
//       itemName: "",
//     }));
//   };


//   const editHandler = async (e) => {
//     if (!state.startingDate && !state.endingDate)
//       return message.error("Please type date !");
//     // if (!state.itemCode) return message.error("Please type Item !");
//     let data = {
//       startingDate: state.startingDate,
//       endingDate: state.endingDate,
//       itemCode: state.itemCode,
//       siteId: Number(user.siteId),
//     };

//     const results = await getSaleReg(data, access_token);
//     if (results.success && results.data.length > 0) {
//       setItemsQueue(results.data);
//     } else {
//       message.error("No Record Found for this date");
//     }
//   };

//   return (
//     <>
//       <Header />
//       <div className="content">
//         {itemsQueue.length > 0 ? (
//           <>
//             <table className="min-w-full leading-normal">
//               <thead>
//                 <tr>
//                   <th>Date</th>
//                   <th>Quantity</th>
//                   <th>Sale Rate</th>
//                   <th>Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {itemsQueue.map((item, index) => (
//                   <tr key={index}>
//                     <td>{item.enteredOn}</td>
//                     <td>{item.quantity}</td>
//                     <td>{item.saleRate}</td>
//                     <td>{item.amount}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 py-1 px-4 rounded" onClick={clearState}>
//               Exit
//             </button>
//           </>
//         ) : (
//           <div className="flex justify-center mt-10">
//             <div className="w-full max-w-md">
//               <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
//                 <div className="mb-4">
//                   <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="startingDate">
//                     Starting Date
//                   </label>
//                   <input
//                     type="datetime-local"
//                     name="startingDate"
//                     onChange={onChangeText}
//                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   />
//                 </div>
//                 <div className="mb-6">
//                   <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="endingDate">
//                     Ending Date
//                   </label>
//                   <input
//                     type="datetime-local"
//                     name="endingDate"
//                     onChange={onChangeText}
//                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   />
//                 </div>
//                 <div className="mb-4">
//                   <Select
//                     showSearch
//                     placeholder="Select item code"
//                     value={state.itemCode || "Select item code"}
//                     onChange={(value) => {
//                       const foundItem = state.items.find(item => item.itemCode === value);
//                       setState({
//                         ...state,
//                         itemCode: value,
//                         itemName: foundItem ? foundItem.itemName : "",
//                       });
//                     }}
//                     className="w-full"
//                   >
//                     {state.items.map(item => (
//                       <Option key={item.itemCode} value={item.itemCode}>{item.itemCode}</Option>
//                     ))}
//                   </Select>
//                 </div>
//                 <div className="mb-4">
//                   <Select
//                     showSearch
//                     placeholder="Select product name"
//                     value={state.itemName || "Select product name"}
//                     onChange={(value) => {
//                       const foundItem = state.items.find(item => item.itemName === value);
//                       setState({
//                         ...state,
//                         itemName: value,
//                         itemCode: foundItem ? foundItem.itemCode : "",
//                       });
//                     }}
//                     className="w-full"
//                   >
//                     {state.items.map(item => (
//                       <Option key={item.itemCode} value={item.itemName}>{item.itemName}</Option>
//                     ))}
//                   </Select>
//                 </div>
//                 <div className="flex items-center justify-between">
//                   <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" onClick={editHandler}>
//                     View
//                   </button>
//                   <button className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" onClick={clearFields}>
//                     Clear
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default SaleRegister;

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { authSelector } from "../../store/selectors";
import { message, Select } from "antd";
import Header from "../header/header";
import { getAllItemsSearch, getSaleReg } from "../../api/endpoints/search";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import "./style.css";
import autoTable from "jspdf-autotable";
const { Option } = Select;

const SaleRegister = () => {
  const { user, access_token } = useSelector(authSelector);
  const [itemsQueue, setItemsQueue] = useState([]);
  const [state, setState] = useState({
    items: [],
    startingDate: "",
    endingDate: "",
    itemCode: "",
    itemName: "",
  });

  useEffect(() => {
    const fetchItems = async () => {
      const result = await getAllItemsSearch(access_token);
      console.log(result, 'state')
      setState({
        ...state,
        items: result,
      });
      // if (result.success) {
      //   setState(prevState => ({
      //     ...prevState,
      //     items: result.data,
      //   }));
      // }
    };
    fetchItems();
  }, [access_token]);


  const onChangeText = (event) => {
    const { name, value } = event.target;
    setState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const clearState = () => {
    setItemsQueue([]);
  };

  const clearFields = () => {
    setState(prevState => ({
      ...prevState,
      startingDate: "",
      endingDate: "",
      itemCode: "",
      itemName: "",
    }));
  };

  // const generatePDF = (data) => {
  //   const doc = new jsPDF();
  
  //   // Sum calculation for numeric columns
  //   const totalQuantity = data.reduce((acc, item) => acc + parseFloat(item.quantity), 0);
  //   const totalAmount = data.reduce((acc, item) => acc + parseFloat(item.amount), 0);
  //   const averageSaleRate = data.reduce((acc, item) => acc + parseFloat(item.saleRate), 0) / data.length;
  
  //   // Append totals to the body data
  //   const bodyData = data.map(item => [
  //     item.enteredOn,
  //     item.quantity.toString(),
  //     item.saleRate.toString(),
  //     item.amount.toString()
  //   ]);
  
  //   // Add a totals row
  //   bodyData.push([
  //     "Totals",
  //     totalQuantity.toFixed(2),
  //     averageSaleRate.toFixed(2),
  //     totalAmount.toFixed(2)
  //   ]);
  
  //   // Generate the table in the PDF
  //   doc.autoTable({
  //     head: [['Date', 'Quantity', 'Sale Rate', 'Amount']],
  //     body: bodyData,
  //     startY: 10
  //   });
  
  //   const pdfOutput = doc.output('bloburl');
  //   window.open(pdfOutput, '_blank');
  // };

  const toSQLDateTime = (value) => {
    if (!value) return null;
    return value.replace("T", " ") + ":00";
  };

  const formatDateOnly = (date) => {
    if (!date) return "";
    const d = new Date(date);
  
    const pad = (n) => n.toString().padStart(2, "0");
  
    return (
      d.getFullYear() +
      "-" +
      pad(d.getMonth() + 1) +
      "-" +
      pad(d.getDate())
    );
  };
  
  
  const generatePDF = (data, startDate, endDate) => {
    if (!data || data.length === 0) return;
  
    const doc = new jsPDF("p", "mm", "a4");
  
    // 🔧 Helpers
    const fmt = (num) =>
      Number(num || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  
    // 🧮 Calculations
    const totalQuantity = data.reduce(
      (acc, item) => acc + (Number(item.quantity) || 0),
      0
    );
  
    const totalAmount = data.reduce(
      (acc, item) => acc + (Number(item.amount) || 0),
      0
    );
  
    const averageSaleRate =
      data.reduce((acc, item) => acc + (Number(item.saleRate) || 0), 0) /
      data.length;
  
    // 🏷️ HEADER
    doc.setTextColor(0, 0, 0);
  
    doc.setFontSize(14);
    doc.text("SALE REGISTER", 105, 12, { align: "center" });
  
    doc.setFontSize(10);
    doc.text(`From: ${startDate}`, 14, 20);
    doc.text(`To: ${endDate}`, 14, 26);
  
    doc.text(`Item: ${data[0]?.itemName || "-"}`, 14, 32);
  
    // 📋 TABLE BODY
    const bodyData = data.map((item) => [
      formatDateOnly(item.enteredOn),
      fmt(item.quantity),
      fmt(item.saleRate),
      fmt(item.amount),
    ]);
  
    // ➕ TOTAL ROW
    bodyData.push([
      { content: "TOTAL", styles: { fontStyle: "bold" } },
      { content: fmt(totalQuantity), styles: { fontStyle: "bold" } },
      { content: fmt(averageSaleRate), styles: { fontStyle: "bold" } },
      { content: fmt(totalAmount), styles: { fontStyle: "bold" } },
    ]);
  
    // 📊 TABLE
    autoTable(doc, {
      head: [["Date", "Quantity", "Sale Rate", "Amount"]],
      body: bodyData,
      startY: 38,
      theme: "grid",
    
      styles: {
        fontSize: 9,
        textColor: [0, 0, 0],
        halign: "right",
        cellPadding: 2,
    
        // ✅ BLACK BORDERS
        lineColor: [0, 0, 0],
        lineWidth: 0.3,
      },
    
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
    
        // ✅ BLACK HEADER BORDERS
        lineColor: [0, 0, 0],
        lineWidth: 0.4,
      },
    
      columnStyles: {
        0: { halign: "left", cellWidth: 35 },
        1: { cellWidth: 35 },
        2: { cellWidth: 35 },
        3: { cellWidth: 40 },
      },
    });
    
  
    // 📤 OPEN PDF
    const pdfUrl = doc.output("bloburl");
    window.open(pdfUrl, "_blank");
  };
  
  
  
  const editHandler = async () => {
    if (!state.startingDate || !state.endingDate) {
      return message.error("Please type date!");
    }
  
    const data = {
      startingDate: toSQLDateTime(state.startingDate),
      endingDate: toSQLDateTime(state.endingDate),
      itemCode: state.itemCode,
      siteId: Number(user.siteId),
    };
  
    const results = await getSaleReg(data, access_token);
  
    if (results.success && results.data.length > 0) {
      setItemsQueue(results.data);
      generatePDF(results.data, data.startingDate, data.endingDate);
    } else {
      message.error("No Record Found for this date");
    }
  };
  
  // const editHandler = async () => {
  //   if (!state.startingDate || !state.endingDate) {
  //     return message.error("Please type date!");
  //   }
  //   let data = {
  //     startingDate: state.startingDate,
  //     endingDate: state.endingDate,
  //     itemCode: state.itemCode,
  //     siteId: Number(user.siteId),
  //   };

  //   const results = await getSaleReg(data, access_token);
  //   if (results.success && results.data.length > 0) {
  //     setItemsQueue(results.data);
  //     generatePDF(results.data);
  //   } else {
  //     message.error("No Record Found for this date");
  //   }
  // };

  return (
    <>
      <Header />
      <div className="">
      <div className="content">
         
          <div className="flex justify-center mt-10">
            <div className="w-full max-w-md">
              <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="startingDate">
                    Starting Date
                  </label>
                  <input
                    type="datetime-local"
                    name="startingDate"
                    onChange={onChangeText}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div className="mb-6">
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="endingDate">
                    Ending Date
                  </label>
                  <input
                    type="datetime-local"
                    name="endingDate"
                    onChange={onChangeText}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div className="mb-4">
                  <Select
                    showSearch
                    placeholder="Select item code"
                    value={state.itemCode || "Select item code"}
                    onChange={(value) => {
                      const foundItem = state.items.find(item => item.itemCode === value);
                      setState({
                        ...state,
                        itemCode: value,
                        itemName: foundItem ? foundItem.itemName : "",
                      });
                    }}
                    className="w-full"
                  >
                    {state.items.map(item => (
                      <Option key={item.itemCode} value={item.itemCode}>{item.itemCode}</Option>
                    ))}
                  </Select>
                </div>
                <div className="mb-4">
                  <Select
                    showSearch
                    placeholder="Select product name"
                    value={state.itemName || "Select product name"}
                    onChange={(value) => {
                      const foundItem = state.items.find(item => item.itemName === value);
                      setState({
                        ...state,
                        itemName: value,
                        itemCode: foundItem ? foundItem.itemCode : "",
                      });
                    }}
                    className="w-full"
                  >
                    {state.items.map(item => (
                      <Option key={item.itemCode} value={item.itemName}>{item.itemName}</Option>
                    ))}
                  </Select>
                </div>
                <div className="flex items-center justify-between">
                  <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" onClick={editHandler}>
                    View
                  </button>
                  <button className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" onClick={clearFields}>
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
     </div>

     </div>
    </>
  );
};

export default SaleRegister;
